module.exports = __webpack_public_path__ + "media/images/explore-820bd73fcc4ba09f43a45412445b84a5.svg";